module.exports = __webpack_public_path__ + "images/623e558392e453b90fff98ecab456245.svg";